import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-command-list-item-template',
    templateUrl: './command-list-item-template.component.html',
    styleUrls: ['./command-list-item-template.component.scss'],
    standalone: false
})
export class CommandListItemTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
